var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZipLineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_474_016919"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 140,
    rx: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_474_016919)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 140,
    rx: 0,
    fill: "#FFFFFF",
    fillOpacity: 0.009999999776482582,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M140,0L0,0L0,140L140,140L140,0Z",
    fill: "#FFFFFF",
    fillOpacity: 0.009999999776482582,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.688729634375,13.024911775Q22.833740234375,14.879901875,22.833740234375,17.503255375000002L22.833740234375,122.503261875Q22.833740234375,125.126661875,24.688731934375,126.981631875Q26.543705434375,128.83658187499998,29.167073734375002,128.83658187499998L110.833740234375,128.83658187499998Q113.457153234375,128.83658187499998,115.312118234375,126.981631875Q117.167076234375,125.126681875,117.167076234375,122.503261875L117.167076234375,40.836585875Q117.167068234375,40.737126875,117.129013234375,40.645242875Q117.090950234375,40.553355875,117.020630234375,40.483031875L87.853958234375,11.316368465Q87.783630234375,11.246042375,87.691742234375,11.207982125000001Q87.599861234375,11.169921905,87.500412234375,11.169921875L29.167073734375002,11.169921875Q26.543719034375002,11.169921875,24.688729634375,13.024911775ZM23.833740234375,122.503261875L23.833740234375,17.503255375000002Q23.833740234375,15.294115075,25.395836634375,13.732018475Q26.957932934375002,12.169921875,29.167073734375002,12.169921875L87.293304234375,12.169921875L116.167076234375,41.043693875L116.167076234375,122.503261875Q116.167076234375,124.712451875,114.605003234375,126.274521875Q113.042930234375,127.836581875,110.833740234375,127.836581875L29.167073734375002,127.836581875Q26.957916734375,127.836581875,25.395834434375,126.274521875Q23.833740234375,124.712451875,23.833740234375,122.503261875Z",
    fillRule: "evenodd",
    fill: "#6A35FF",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.9292988,95L84,95L84,94L49.0707014,94L85.070702,51L48,51L48,52L82.929302,52L46.9292988,95Z",
    fillRule: "evenodd",
    fill: "#6A35FF",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipLineIcon);
export default __webpack_public_path__ + "static/media/zipLineIcon.1f004d66cc404f15f61830bc1078e994.svg";
export { ForwardRef as ReactComponent };